$("a.videoblock").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    classAttributes = `${video.attr('class') && `class="${video.attr('class')}"`}`;
    dataAttributes = `${video.data('mfp-src') && `data-mfp-src="${video.data('mfp-src')}"`}`;
    ariaAttributes = `${video.attr('aria-label') && `aria-label="${video.attr('aria-label')}"`}`;
    // Apply attributes
    const buttonAttributes = `${classAttributes} ${dataAttributes} ${ariaAttributes}`;

    // Construct and replace with button
    video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
});